import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import { IAuthorization, IUser, IUserGroup_Authorization, IUser_Group } from 'bets.oddprovider.lib.common.ts/models';
import * as React from 'react';
import { UserGroupAuthorizationsComponent } from './userGroupAuthorizations';
import { UserGroupUsersComponent } from './userGroupUsers';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      {...other}
    >
      {value === index && children}
    </div>
  );
}

function tabProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export const UserGroupAddInfoTabsComponent = (props: {
  users_groups?: IUser_Group[],
  onSelectUser?: ((item: IUser_Group, user: IUser) => void) | undefined,
  onDeleteUser?: (item: IUser_Group) => void,
  onAddUser?: () => void,

  usersgroups_authorizations?: IUserGroup_Authorization[],
  onSelectAuthorization?: ((item: IUserGroup_Authorization, authorization: IAuthorization) => void) | undefined,
  onDeleteAuthorization?: (item: IUserGroup_Authorization) => void,
  onAddAuthorization?: () => void
}) => {
  const [currTab, setCurrTab] = React.useState(0);

  const onTabChange = (event: React.SyntheticEvent, newTabIndex: number) => {
    setCurrTab(newTabIndex);
  };

  return <>
    <Box sx={{ width: '100%', mt: 2 }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={currTab} onChange={onTabChange} indicatorColor="primary" textColor="primary" variant="fullWidth">
          <Tab label="Usuários" {...tabProps(0)} />
          <Tab label="Autorizações" {...tabProps(1)} />
        </Tabs>
      </Box>
      <TabPanel value={currTab} index={0}>
        <UserGroupUsersComponent
          data={props.users_groups}
          onSelectItem={props.onSelectUser}
          onDelete={props.onDeleteUser}
          onAdd={props.onAddUser}
        />
      </TabPanel>
      <TabPanel value={currTab} index={1}>
        <UserGroupAuthorizationsComponent
          data={props.usersgroups_authorizations}
          onSelectItem={props.onSelectAuthorization}
          onDelete={props.onDeleteAuthorization}
          onAdd={props.onAddAuthorization}
        />
      </TabPanel>
    </Box>
  </>
}